import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type StatusBadgeStatus = 'success' | 'warning' | 'danger' | 'neutral';

@Component({
  selector: 'app-status-badge',
  standalone: false,
  template: '<span class="status-badge" [class]="statusClass">{{ label }}</span>',
  styleUrls: ['./status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusBadgeComponent {
  @Input() status: StatusBadgeStatus = 'neutral';
  @Input() label = '';

  get statusClass(): string {
    return `status-badge--${this.status}`;
  }
}